export default {"src":"/_next/static/media/instagram-white-bg.2ccf350c.svg","height":24,"width":24};